import { useDispatch, useSelector } from "react-redux";
import useFetchAllExchangesWithCoins from "../../hooks/api/useFetchAllExchangesWithCoins";
import { useMemo } from "react";
import capitalize from "antd/es/_util/capitalize";
import styles from "../../styles/shared/other-coins-signal/OtherExchangesList.module.css";
import { analyzeOtherCoins } from "../../redux/analyze-other-coins/otherCoinsAnalyzeSlice";
import useUserData from "../../hooks/useUserData";

function OtherExchangesList({
  currentExchange,
  controllerRef,
  setShowExchanges,
}) {
  const {
    otherCoinsAnalyze: { result },
    tradingAssistant: { aiMarketType },
  } = useSelector((state) => state);

  const { coin_analytics_failed_coins_list: failed = [] } = result;

  const { allExchangesWithCoins: exchanges } = useFetchAllExchangesWithCoins();
  const { email, username } = useUserData();

  const failedMessage =
    failed?.length > 1
      ? "Sorry, no exchange supports the full set of selected coins."
      : "Sorry, no other exchange supports the selected coin.";

  const dispatch = useDispatch();

  const availableExchanges = useMemo(() => {
    return exchanges
      .filter((ex) => {
        const exchangeCoins = ex.coins?.map(
          (coin) => coin?.Coin?.split("/")?.[0],
        );
        const coinSet = new Set(exchangeCoins);
        const failedCoins = failed.map((coin) => coin?.split("/")?.[0]);
        return failedCoins.every((coin) => coinSet.has(coin));
      })
      .map((item) => item.exchange)
      ?.filter((exchange) => exchange !== currentExchange.toLowerCase());
  }, [currentExchange, exchanges, failed]);

  const clickHandler = (exchange) => () => {
    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    setShowExchanges(false);

    dispatch(
      analyzeOtherCoins(
        username,
        email,
        aiMarketType,
        failed,
        exchange?.toLowerCase(),
        signal,
      ),
    );
  };

  if (!exchanges.length)
    return <h4 className={styles.emptyMessage}>{failedMessage}</h4>;

  return (
    <ul className={styles.exchanges}>
      {availableExchanges.map((exchange) => (
        <li
          key={exchange}
          className={styles.exchangeItem}
          onClick={clickHandler(exchange)}
        >
          {capitalize(exchange)}
        </li>
      ))}
    </ul>
  );
}

export default OtherExchangesList;
